export default __webpack_public_path__ + "static/media/rankbadge.8684f6af.png";